(() => {
  if (window.flaskGiftingFormsInitialized) return;
  window.flaskGiftingFormsInitialized = true;
  const reveal = (notice) => {
    const header = document.getElementById('HeaderWrapper');
    notice.style.scrollMarginTop = `${(header ? header.getBoundingClientRect().height : 0) + 16}px`;
    notice.focus({ preventScroll: true });
    notice.scrollIntoView({ block: 'start', behavior: 'instant' });
  };
  // Native responses still need focus when dedicated and native instances coexist.
  const nativeNotices = document.querySelectorAll('.fg-form:not([data-gifting-email]) .fg-notice');
  const target = nativeNotices.length ? document.getElementById(window.location.hash.slice(1)) : null;
  const targetForm = target?.closest('form');
  const notice = Array.from(nativeNotices).find(element => element.closest('form') === targetForm) || nativeNotices[0];
  if (notice && !notice.dataset.giftingNoticeInitialized) {
    notice.dataset.giftingNoticeInitialized = 'true';
    const schedule = () => requestAnimationFrame(() => {
      const active = document.activeElement;
      const activeForm = active.closest('form');
      if (activeForm && active !== activeForm && active !== notice) return;
      reveal(notice);
    });
    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }
  const cleanups = new WeakMap();
  const initializeForm = (form) => {
    if (form.dataset.giftingInitialized) return;
    form.dataset.giftingInitialized = 'true';
    const button = form.querySelector('button[type="submit"]');
    const notice = form.querySelector('[data-gifting-notice]');
    const label = button.textContent;
    let token = '';
    let widget;
    let pending = false;
    let disposed = false;
    let lastPayload;
    let requestId;
    const feedback = (message, success = false, focus = true) => {
      if (disposed) return;
      // Shopify translations can HTML-encode apostrophes before attribute escaping.
      notice.textContent = message.replace(/&#39;/g, "'");
      notice.className = `fg-notice fg-notice--${success ? 'success' : 'error'}`;
      notice.setAttribute('role', success ? 'status' : 'alert');
      notice.hidden = false;
      if (focus) reveal(notice);
    };
    const expire = () => { token = ''; button.disabled = true; };
    const submit = async (event) => {
      event.preventDefault();
      if (pending || !form.reportValidity()) return;
      if (!token) { feedback(form.dataset.verification); return; }
      const data = new FormData(form);
      const fields = {
        name: data.get('contact[name]'), email: data.get('contact[email]'),
        company: data.get('contact[Company]'), phone: data.get('contact[phone]'), message: data.get('contact[body]'),
      };
      const payload = JSON.stringify(fields);
      if (payload !== lastPayload) { requestId = crypto.randomUUID(); lastPayload = payload; }
      pending = true;
      button.disabled = true;
      button.textContent = form.dataset.sending;
      form.setAttribute('aria-busy', 'true');
      notice.hidden = true;
      try {
        const endpoint = new URL(form.dataset.endpoint);
        if (endpoint.protocol !== 'https:') throw new Error('configuration');
        const response = await fetch(endpoint.href, {
          method: 'POST', credentials: 'omit', signal: AbortSignal.timeout(30000),
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...fields, token, requestId }),
        });
        const result = await response.json();
        if (!response.ok || result.ok !== true || result.code !== 'accepted') {
          feedback(response.status === 429 ? form.dataset.rateLimit : result.code === 'verification' ? form.dataset.verification : form.dataset.error);
        } else {
          form.reset();
          lastPayload = undefined;
          feedback(form.dataset.success, true);
        }
      } catch {
        feedback(form.dataset.error);
      } finally {
        pending = false;
        expire();
        button.textContent = label;
        form.removeAttribute('aria-busy');
        // Every Siteverify attempt consumes a token; a retry must get a fresh one.
        if (widget !== undefined && window.turnstile) window.turnstile.reset(widget);
      }
    };
    form.addEventListener('submit', submit);
    cleanups.set(form, () => {
      form.removeEventListener('submit', submit);
      disposed = true;
      if (widget !== undefined && window.turnstile) window.turnstile.remove(widget);
      widget = undefined;
      cleanups.delete(form);
      delete form.dataset.giftingInitialized;
    });
    const mount = () => {
      if (disposed) return;
      try {
        widget = window.turnstile.render(form.querySelector('[data-gifting-turnstile]'), {
          sitekey: form.dataset.sitekey, action: 'corporate_gifting', theme: 'light', size: 'flexible',
          callback: (value) => { token = value; button.disabled = pending; },
          'expired-callback': expire,
          'error-callback': () => { expire(); feedback(form.dataset.verification, false, false); },
        });
      } catch { feedback(form.dataset.verification, false, false); }
    };
    if (window.turnstile) mount();
    else {
      const load = async () => {
        try {
          window.flaskGiftingTurnstileReady ||= new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
            script.async = true;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
          });
          await window.flaskGiftingTurnstileReady;
          mount();
        } catch { feedback(form.dataset.verification, false, false); }
      };
      load();
    }
  };
  const initializeForms = (root = document) => {
    for (const form of root.querySelectorAll('form[data-gifting-email]')) initializeForm(form);
  };
  initializeForms();
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', event => initializeForms(event.target));
    document.addEventListener('shopify:section:unload', event => {
      for (const form of event.target.querySelectorAll('form[data-gifting-email]')) cleanups.get(form)?.();
    });
  }
})();
